<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.eifl_cd_codigo }} - {{ $t('descricao') }} :
								{{ item.eifl_ds_descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVProcessamentoInventarioFlorestal()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			:is-official="model.inventarioOficial"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
			@sortConfigDate="sortConfigDate($event)"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<GridPagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="totalRecords"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
				@refreshTable="refreshTabela"
			/>
		</div>
		<CrudForm
			:backdrop="!planejamentoModelo"
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
		>
			<template #form>
				<OfficialProcessingIcon
					:inventario-oficial="model.inventarioOficial"
					:is-list-view="false"
					@definirComoProcessamentoOficial="setarComoProcessamentoOficial(model)"
				/>
				<InputText
					v-model="model.eifl_ds_descricao"
					style="margin: 0.5rem 0"
					:label="$t('description')"
					@input="onDescriptionChange"
				/>

				<RadioButtons
					v-if="!planejamentoModelo"
					v-model="tipoProcessamento"
					group-name="tipo-processamento"
					:label="$t('typeOfProcessing')"
					:options="[
						{ label: $t('traditional'), value: 'tradicional' },
						{ label: $t('singleTrees'), value: 'singletrees' },
					]"
					:disabled="isEdit"
				/>

				<!-- <Switcher
          :disabled="isEdit"
          style="margin-top: 1rem;"
          :leftLabel="$t('traditional')"
          :label="$t('singleTrees')"
          v-model="isSingleTrees"
        /> -->

				<DropdownCheckboxFKMedicao
					v-if="!isSingleTrees"
					v-model="model.fk_mdco_medicao"
					style="margin: 0.5rem 0"
					:disabled="isEdit"
					:label="$t('measurement')"
					:dropdown-options="medicoesComputadas"
					:checkbox-label="$t('rawMeasurement')"
					:disabled-checkbox="isEdit"
					@checkboxEvent="handleCheckboxChange($event)"
				/>

				<DropdownFk
					v-if="isSingleTrees"
					v-model="model.fk_orsv_ordem_servico"
					style="margin: 0.5rem 0"
					:label="$t('serviceOrder')"
					:disabled="isEdit"
					:dropdown-options="ordensServicoFormatadas"
				/>

				<DropdownFk
					v-model="model.fk_eicb_estrato_invcbg"
					style="margin: 0.5rem 0"
					:label="$t('loggingInventory')"
					:disabled="isEdit"
					:dropdown-options="cubagens"
					:hidden-properties="[
						'nomeModelo',
						'eicb_tx_modelo_ajustado',
						'eicb_cd_codigo',
						'eicb_ds_descricao',
						'eicb_dt_processamento',
						'eicb_tx_tipo_modelo',
						'cubagem',
						'possuiDependenciaDeRegistro',
						'cbgm_cd_codigo',
						'cbgm_ds_descricao',
					]"
				/>

				<Dropdown
					v-if="isSingleTrees"
					v-model="model.eifl_nm_metodologia_nfustes"
					:disabled="isEdit"
					:label="`${$t('methodology')} ${$t('stemNumber')}`"
					:options="[
						{ value: 'EspacamentoTeorico', label: $t('theoretical') },
						{ value: 'AreaBasalBitterlich', label: $t('bitterlich') },
						{ value: 'Mapeamento', label: $t('mapping') },
						{ value: 'MortalidadeRoleta', label: $t('roullete') },
					]"
				/>

				<RadioButtons
					v-if="!planejamentoModelo"
					v-model.number="model.eifl_md_nivel_significancia"
					group-name="nivel-dignificancia"
					:label="$t('significanceLevel')"
					:options="[
						{ label: '90%', value: 0.1 },
						{ label: '95%', value: 0.05 },
						{ label: '99%', value: 0.01 },
					]"
					:disabled="isEdit"
				/>

				<!-- <div style="margin: 0.5rem 0;">
          <label>Nível de Significância</label>
          <div style="display: flex; gap: 1rem;">
            <Button
              label="90%"
              color="trv-primary"
              :outlined="!(model.eifl_md_nivel_significancia === 0.10)"
              @click="model.eifl_md_nivel_significancia = 0.10"
              semanticClass="mini"
              :disabled="isEdit"
            />
            <Button
              label="95%"
              color="trv-primary"
              :outlined="!(model.eifl_md_nivel_significancia === 0.05)"
              @click="model.eifl_md_nivel_significancia = 0.05"
              semanticClass="mini"
              :disabled="isEdit"
            />
            <Button
              label="99%"
              color="trv-primary"
              :outlined="!(model.eifl_md_nivel_significancia === 0.01)"
              @click="model.eifl_md_nivel_significancia = 0.01"
              semanticClass="mini"
              :disabled="isEdit"
            />
          </div>
        </div> -->

				<InputText
					v-show="isProcessamentoCubagemAfilamento"
					v-model="model.eifl_md_altura_toco"
					style="margin: 0.5rem 0"
					:label="$t('stumpHeight')"
					:disabled="isEdit"
				/>

				<DropdownCheckboxFk
					v-if="isProcessamentoCubagemAfilamento"
					v-model="produtosSelecionados"
					style="margin: 0.5rem 0"
					:disabled="isEdit"
					:label="$t('products')"
					:dropdown-options="produtosFormatados"
					:ignore-properties="['id']"
				/>

				<!-- <Switcher
					v-show="produtosSelecionados.length > 1"
					v-model="model.eifl_is_subsequente"
					:disabled="isEdit"
					style="padding: 1rem 0"
					:label="$t('subsequentProducts')"
				/> -->

				<label style="margin-bottom: 0.5rem">{{ $t('hypsometricAdjustmentLevel') }}</label>

				<div style="display: flex; gap: 0.5rem; flex-direction: column">
					<div style="display: flex; flex-wrap: wrap; gap: 0.5rem; padding: 0.5rem">
						<TagWithButton
							:disabled="isEdit"
							:button-icon="variaveis.includes('eiflid') ? 'fas fa-minus' : 'fas fa-plus'"
							:class-name="variaveis.includes('eiflid') ? 'default' : 'default outlined'"
							:label="$t('forestStratification')"
							@clickEvent="handleVariaveis('eiflid')"
						/>
						<TagWithButton
							:disabled="isEdit"
							:button-icon="variaveis.includes('ptio_dt_plantio') ? 'fas fa-minus' : 'fas fa-plus'"
							:class-name="variaveis.includes('ptio_dt_plantio') ? 'default' : 'default outlined'"
							:label="$t('age')"
							@clickEvent="handleVariaveis('ptio_dt_plantio')"
						/>
						<TagWithButton
							:disabled="isEdit"
							:button-icon="variaveis.includes('mtge_cd_codigo') ? 'fas fa-minus' : 'fas fa-plus'"
							:class-name="variaveis.includes('mtge_cd_codigo') ? 'default' : 'default outlined'"
							:label="$t('geneticMaterial')"
							@clickEvent="handleVariaveis('mtge_cd_codigo')"
						/>
						<TagWithButton
							:disabled="isEdit"
							:button-icon="variaveis.includes('tlho_cd_codigo') ? 'fas fa-minus' : 'fas fa-plus'"
							:class-name="variaveis.includes('tlho_cd_codigo') ? 'default' : 'default outlined'"
							:label="$t('section')"
							@clickEvent="handleVariaveis('tlho_cd_codigo')"
						/>
						<TagWithButton
							v-show="!isSingleTrees"
							:disabled="isEdit"
							:button-icon="variaveis.includes('prlaid') ? 'fas fa-minus' : 'fas fa-plus'"
							:class-name="variaveis.includes('prlaid') ? 'default' : 'default outlined'"
							:label="$t('plot')"
							@clickEvent="handleVariaveis('prlaid')"
						/>
					</div>

					<h4
						v-show="!isEdit"
						class="text-xl font-bold mt-4"
						style="margin-bottom: 0"
					>
						{{ $t('processingModel') }}
					</h4>
					<p v-show="!isEdit">
						{{ $t('helpProcessingModel') }}
					</p>

					<div style="gap: 1.5rem; display: flex; padding: 1rem 0">
						<CardPicker
							v-show="!isEdit"
							soon
							:selected="!avancado"
						>
							<template #header>
								{{ $t('automatic') }}
							</template>
							<template #description>
								{{ $t('helpAutomatic') }}
							</template>
							<template #button-title>
								{{ !avancado ? $t('selected') : $t('select') }}
							</template>
						</CardPicker>

						<CardPicker
							v-show="!isEdit"
							:selected="avancado"
							@click="handleClick('avancado')"
						>
							<template #header>
								{{ $t('advanced') }}
							</template>
							<template #description>
								{{ $t('helpAdvanced') }}
							</template>
							<template #button-title>
								{{ avancado ? $t('selected') : $t('select') }}
							</template>
						</CardPicker>
					</div>

					<div style="display: flex; justify-content: space-between; padding: 0.5rem 0">
						<div />
						<p
							v-if="isEdit"
							class="go__to__plan__text"
							@click="verPlanejamento"
						>
							<Loading
								v-if="!modeloSalvo"
								style="width: fit-content"
							/>
							<span v-if="modelos.length > 1"> {{ $t('continuarParaAescolha') + '➝' }} </span>
							<span v-else>{{ `${$t('view')} ${$t('model')} ➝` }}</span>
						</p>
					</div>
				</div>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('cancel')"
						color="trv-secondary"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
					<Button
						v-if="!isEdit"
						:label="
							avancado ? (isEdit ? $t('edit') : $t('process')) : isEdit ? $t('edit') : $t('process')
						"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						v-if="descriptionChanged"
						:label="$t('save')"
						color="trv-default"
						@click="saveClick"
					/>
				</div>
			</template>
		</CrudForm>
		<ProcessamentoAvancado
			v-if="planejamentoModelo"
			:modelo="modelos[index]"
		>
			<template #registry-fields>
				<div
					id="registry__fields"
					style="padding: 1.5rem; height: 100%; max-height: 70vh; overflow: auto"
				>
					<InputText
						v-model="model.eifl_ds_descricao"
						style="margin: 0.5rem 0"
						:label="$t('description')"
					/>

					<!-- <Switcher
            :disabled="isEdit"
            style="margin-top: 1rem;"
            :leftLabel="$t('traditional')"
            :label="$t('singleTrees')"
            v-model="isSingleTrees"
          /> -->

					<RadioButtons
						v-if="planejamentoModelo"
						v-model="tipoProcessamento"
						group-name="tipo-processamento"
						:label="$t('typeOfProcessing')"
						:options="[
							{ label: $t('traditional'), value: 'tradicional' },
							{ label: $t('singleTrees'), value: 'singletrees' },
						]"
					/>

					<DropdownFk
						v-if="!isSingleTrees"
						v-model="model.fk_mdco_medicao"
						style="margin: 0.5rem 0"
						:label="$t('measurement')"
						:dropdown-options="medicoesComputadas"
						:disabled="isEdit"
					/>

					<DropdownFk
						v-if="isSingleTrees"
						v-model="model.fk_orsv_ordem_servico"
						:label="$t('serviceOrder')"
						:dropdown-options="ordensServicoFormatadas"
						:disabled="isEdit"
					/>

					<DropdownFk
						v-model="model.fk_eicb_estrato_invcbg"
						style="margin: 0.5rem 0"
						:label="$t('loggingInventory')"
						:dropdown-options="cubagens"
						:hidden-properties="[
							'nomeModelo',
							'eicb_tx_modelo_ajustado',
							'eicb_cd_codigo',
							'eicb_ds_descricao',
							'eicb_dt_processamento',
							'eicb_tx_tipo_modelo',
							'cubagem',
							'possuiDependenciaDeRegistro',
							'cbgm_cd_codigo',
							'cbgm_ds_descricao',
						]"
						:disabled="isEdit"
					/>

					<Dropdown
						v-if="isSingleTrees"
						v-model="model.eifl_nm_metodologia_nfustes"
						:disabled="isEdit"
						:label="`${$t('methodology')} ${$t('stemNumber')}`"
						:options="[
							{ value: 'EspacamentoTeorico', label: $t('theoretical') },
							{ value: 'AreaBasalBitterlich', label: $t('bitterlich') },
							{ value: 'Mapeamento', label: $t('mapping') },
							{ value: 'MortalidadeRoleta', label: $t('roullete') },
						]"
					/>

					<RadioButtons
						v-model.number="model.eifl_md_nivel_significancia"
						group-name="nivel-dignificancia"
						:label="$t('significanceLevel')"
						:options="[
							{ label: '90%', value: 0.1 },
							{ label: '95%', value: 0.05 },
							{ label: '99%', value: 0.01 },
						]"
					/>

					<!-- <div style="margin: 0.5rem 0;">
            <label>{{ $t('significanceLevel') }}</label>
            <div style="display: flex; gap: 1rem;">
              <Button
                label="90%"
                color="trv-primary"
                :outlined="!(model.eifl_md_nivel_significancia === 0.10)"
                @click="model.eifl_md_nivel_significancia = 0.10"
                semanticClass="mini"
                :disabled="isEdit"
              />
              <Button
                label="95%"
                color="trv-primary"
                :outlined="!(model.eifl_md_nivel_significancia === 0.05)"
                @click="model.eifl_md_nivel_significancia = 0.05"
                semanticClass="mini"
                :disabled="isEdit"
              />
              <Button
                label="99%"
                color="trv-primary"
                :outlined="!(model.eifl_md_nivel_significancia === 0.01)"
                @click="model.eifl_md_nivel_significancia = 0.01"
                semanticClass="mini"
                :disabled="isEdit"
              />
            </div>
          </div> -->

					<InputText
						v-show="isProcessamentoCubagemAfilamento"
						v-model="model.eifl_md_altura_toco"
						style="margin: 0.5rem 0"
						:label="$t('stumpHeight')"
						:disabled="isEdit"
					/>

					<DropdownCheckboxFk
						v-if="isProcessamentoCubagemAfilamento"
						v-model="produtosSelecionados"
						style="margin: 0.5rem 0"
						:label="$t('products')"
						:dropdown-options="produtosFormatados"
						:ignore-properties="['id']"
						:disabled="isEdit"
					/>

					<!-- <Switcher
						v-show="produtosSelecionados.length > 1"
						v-model="model.eifl_is_subsequente"
						:disabled="isEdit"
						style="margin-top: 0.5rem"
						:label="$t('subsequentProducts')"
					/> -->

					<label style="margin-bottom: 0.5rem">{{ $t('hypsometricAdjustmentLevel') }}</label>
					<div style="display: flex; gap: 0.5rem; flex-wrap: wrap">
						<TagWithButton
							:button-icon="variaveis.includes('eiflid') ? 'fas fa-minus' : 'fas fa-plus'"
							:class-name="variaveis.includes('eiflid') ? 'default' : 'default outlined'"
							:label="$t('forestStratification')"
							@clickEvent="handleVariaveis('eiflid')"
						/>
						<TagWithButton
							:button-icon="variaveis.includes('ptio_dt_plantio') ? 'fas fa-minus' : 'fas fa-plus'"
							:class-name="variaveis.includes('ptio_dt_plantio') ? 'default' : 'default outlined'"
							:label="$t('age')"
							@clickEvent="handleVariaveis('ptio_dt_plantio')"
						/>
						<TagWithButton
							:button-icon="variaveis.includes('mtge_cd_codigo') ? 'fas fa-minus' : 'fas fa-plus'"
							:class-name="variaveis.includes('mtge_cd_codigo') ? 'default' : 'default outlined'"
							:label="$t('geneticMaterial')"
							@clickEvent="handleVariaveis('mtge_cd_codigo')"
						/>
						<TagWithButton
							:button-icon="variaveis.includes('tlho_cd_codigo') ? 'fas fa-minus' : 'fas fa-plus'"
							:class-name="variaveis.includes('tlho_cd_codigo') ? 'default' : 'default outlined'"
							:label="$t('section')"
							@clickEvent="handleVariaveis('tlho_cd_codigo')"
						/>
						<TagWithButton
							v-show="!isSingleTrees"
							:button-icon="variaveis.includes('prlaid') ? 'fas fa-minus' : 'fas fa-plus'"
							:class-name="variaveis.includes('prlaid') ? 'default' : 'default outlined'"
							:label="$t('plot')"
							@clickEvent="handleVariaveis('prlaid')"
						/>

						<!-- <label for="estrato">
              <input
                @click="handleNivel($event)"
                v-model="nivelEstrato"
                value="eiflid"
                type="radio"
                name="nivel-unico"
                id="estrato"
                :disabled="isEdit"
              >
              {{ $t('forestStratification') }}
            </label>

            <label for="idade">
              <input
                @click="handleNivel($event)"
                v-model="nivelEstrato"
                value="ptio_dt_plantio"
                type="radio"
                name="nivel-unico"
                id="idade"
                :disabled="isEdit"
              >
              {{ $t('age') }}
            </label>

            <label for="matgen">
              <input
                @click="handleNivel($event)"
                type="radio"
                name="nivel"
                id="matgen"
                value="mtge_cd_codigo"
                v-model="nivelMatgen"
                :disabled="isEdit"
              >
              {{ $t('geneticMaterial') }}
            </label>

            <label for="talhao">
              <input
                @click="handleNivel($event)"
                v-model="nivelEstrato"
                value="tlho_cd_codigo"
                type="radio"
                name="nivel-unico"
                id="talhao"
                :disabled="isEdit"
              >
              {{ $t('section') }}
            </label>

            <label
              v-show="!isSingleTrees"
              for="parcela"
            >
              <input
                @click="handleNivel($event)"
                v-model="nivelEstrato"
                value="prlaid"
                type="radio"
                name="nivel-unico"
                id="parcela"
                :disabled="isEdit"
              >
              {{ $t('plot') }}

            </label> -->
					</div>
				</div>
			</template>

			<template #modeling-preview>
				<ModelPreviewTemp
					v-if="modelos.length"
					v-model="modeloEscolhido"
					:edit="isEdit"
					:model="modelos[index] || {}"
					@search="searchModel"
				>
					<div>
						<div
							v-if="modelos.length > 1"
							style="display: flex; justify-content: center"
						>
							<Tag
								:label="`${index + 1}/${modelos.length}`"
								class-name="default outlined"
							/>
						</div>
						<div
							v-if="modelos.length > 1"
							style="
								width: 100%;
								display: flex;
								justify-content: center;
								gap: 1rem;
								margin-bottom: 0.5rem;
								margin-top: 0.5rem;
								padding: 0 5rem;
							"
						>
							<Button
								:disabled="index === 0"
								icon="fas fa-caret-left"
								color="trv-primary"
								semantic-class="tiny"
								@click="index--"
							/>
							<Button
								:loading="escolhendoModelo"
								color="trv-default"
								:label="`${$t('pickModel')}`"
								semantic-class="tiny"
								@click="saveModel"
							/>

							<Button
								:disabled="index === modelos.length - 1"
								icon="fas fa-caret-right"
								color="trv-primary"
								semantic-class="tiny"
								@click="index++"
							/>
						</div>
					</div>
				</ModelPreviewTemp>
				<div
					v-else
					style="
						display: flex;
						flex-direction: column;
						justify-content: center;
						height: 100%;
						align-content: center;
						align-items: center;
					"
				>
					<Loading
						v-if="mostrarLoadingProcessando"
						style="height: 25px; width: 25px"
					/>
					<label style="display: flex; align-items: center; font-size: 1rem; margin-top: 0"
						>{{ mensagemProcessando }}
					</label>
				</div>
			</template>

			<template #action-buttons>
				<div style="display: flex; padding: 1.5rem">
					<Button
						:label="$t('back')"
						color="trv-secondary"
						outlined
						@click="
							planejamentoModelo = false
							showForm = true
						"
					/>
					<Button
						:label="$t('process')"
						:loading="processando"
						semantic-class="tiny"
						@click="registraInventarioFlorestal"
					/>
				</div>
			</template>

			<!-- <template v-slot:checkout-preview>
        <h3 style="text-align: center; padding: 2rem;">{{ modelos[index] ? modelos[index].stan_nm_modelo : ""  }}</h3>
        <div style="padding: 1.5rem;">
          <Button
            :disabled="!modeloEscolhido"
            :label="$t('save')"
            semanticClass="tiny"
            @click="saveModel"
          />
        </div>

      </template> -->
		</ProcessamentoAvancado>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import Dropdown from '../../../components/Dropdown/Dropdown'
import GridPagination from '../../../components/GridPagination/GridPagination.vue'
import RadioButtons from '../../../components/RadioButtons/RadioButtons'
import Tag from '../../../components/Tag/Tag'
import TagWithButton from '../../../components/TagWithButton/TagWithButton'

// import DownloadButton from "../../../components/DownloadButton/DownloadButton";
import CardPicker from '../../../components/CardPicker/CardPicker'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownCheckboxFk from '../../../components/DropdownCheckboxFk/DropdownCheckboxFk'
import DropdownFk from '../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Loading from '../../../components/Loading/Loading'
import Switcher from '../../../components/Switcher/Switcher'

import ModelPreviewTemp from '../../../components/ModelPreviewTemp/ModelPreviewTemp.vue'
import ProcessamentoAvancado from '../ProcessamentoAvancado.vue'

import { getAllEstratoInventarioCubagem } from '../../../services/requests/EstratoInventarioCubagemRequests'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import { getAllProdutos } from '../../../services/requests/ProdutoRequest'

import {
	ajustaModeloHipsometrico,
	createEstratoInventario,
	deleteEstratoInventarioFlorestalByIdList,
	getAllEstratosInventarioFlorestalPagination,
	getAllHipsometricoWithGraphicByEiflId,
	processaInventario,
	saveChosenHipsometricoModel,
	updateEstratoInventarioFlorestalAsync,
} from '../../../services/requests/EstratoInventarioFlorestalRequests'

import { processarQualidadeParaInventarioTradicional } from '../../../services/requests/EstratoInventarioDeQualidadeRequests'

import { getDropdownMedicaoProcessamento } from '../../../services/requests/MedicoesInventarioRequests'

import { getDropdownEstratosFlorestais } from '../../../services/requests/EstratoFlorestalRequests' //alterar diretorio

import { getInstalacoesSingleTrees } from '../../../services/requests/OrdemDeServicoRequests'

import download from 'downloadjs'
import OfficialProcessingIcon from '../../../components/OfficialProcessingIcon/OfficialProcessingIcon.vue'
import { classificaComoInventarioOficial } from '../../../services/requests/EstratoInventarioFlorestalRequests'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'
import DropdownCheckboxFKMedicao from '../../../components/DropdownCheckboxFkMedicao/DropdownCheckboxFKMedicao.vue'

export default {
	name: 'ProcessamentoInventario',
	components: {
		DropdownCheckboxFKMedicao,
		RadioButtons,
		TagWithButton,
		DropdownCheckboxFk,
		Button,
		CrudForm,
		CrudTable,
		CardPicker,
		ProcessamentoAvancado,
		ModelPreviewTemp,
		KebabMenu,
		Tag,
		Dropdown,
		// DownloadButton,
		DropdownCheckbox,
		Switcher,
		Loading,
		DropdownFk,
		InputSearch,
		InputText,
		OfficialProcessingIcon,
		GridPagination,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	provide() {
		return {
			edit: this.edit,
		}
	},
	data() {
		return {
			tipoProcessamento: 'tradicional',
			medicoesOriginal: [],
			filtrarMedicaoBruta: false,
			variaveis: [],
			totalRecords: 0,
			textFilter: '',
			showExclusionAlert: false,
			descricao: '',
			modeloSalvo: undefined,
			escolhendoModelo: false,
			processando: false,
			descriptionChanged: false,
			initialDescription: '',
			headersSelecionados: [
				'estrato',
				'eifl_tx_status',
				'medicao',
				'eifl_ds_descricao',
				'eifl_cd_codigo',
				'nomeModelo',
				'eifl_dt_processamento',
				'inventarioOficial',
			],
			ordensServico: [],
			medicoes: [],
			nivelMatgen: '',
			modeloEscolhido: '',
			index: 0,
			modelos: [],
			avancado: true,
			nivelEstrato: '',
			produtosSelecionados: [],
			niveisAjuste: [
				{ key: 'parcela', value: this.$t('plot'), isActive: false },
				{ key: 'talhao', value: this.$t('section'), isActive: false },
				{ key: 'matgen', value: this.$t('geneticMaterial'), isActive: false },
				{ key: 'idade', value: this.$t('age'), isActive: false },
				{
					key: 'estrato',
					value: this.$t('forestStratification'),
					isActive: false,
				},
			],
			inventarioCubagens: [],
			produtos: [],
			intention: {},
			planejamentoModelo: false,
			mostrarLoadingProcessando: false,
			mensagemProcessando: this.$t('realizeOProcessamento'),

			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				eifl_ds_descricao: '',
				fk_mdco_medicao: '',
				fk_orsv_ordem_servico: '',
				fk_eicb_estrato_invcbg: '',
				eifl_is_subsequente: false,
				eifl_md_nivel_significancia: 0.05,
				eifl_md_altura_toco: 0.1,
				inventarioOficial: true,
				novoInventario: false,
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'OS',
				subtitleCardPropertie: 'eifl_ds_descricao',
				titleCardPropertie: 'eifl_ds_descricao',
			},
			tableHeaders: [
				{ key: 'eifl_cd_codigo', value: this.$t('code'), isActive: true }, //alterar variavel
				{ key: 'eifl_dt_processamento', value: this.$t('processingDate'), isActive: true },
				{
					key: 'eifl_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{
					key: 'estrato',
					value: this.$t('forestStratification'),
					isActive: true,
				},
				{
					key: 'ordemDeServico',
					value: this.$t('serviceOrder'),
					isActive: false,
				},
				{ key: 'medicao', value: this.$t('measurement'), isActive: true }, //alterar variavel
				{ key: 'eifl_tx_status', value: this.$t('status'), isActive: true }, //alterar variavel
				{ key: 'nomeModelo', value: this.$t('model'), isActive: true }, //alterar variavel
				{ key: 'inventarioOficial', value: this.$t('registration_status'), isActive: false },
			],
			/**
			 *Estratos florestais cadastrados no banco de dados
			 */
			estratosFlorestais: [], //alterar variavel

			/**
			 * Todos os Executores cadastrados no banco de dados
			 */
			executores: [], //alterar variavel

			/**
			 *Tipos de Servicos cadastrados no banco de dados
			 */
			tiposDeServico: [], //alterar variavel

			/**
			 * ExecutoresSelecionados para DropdownCheckboxFk
			 */
			executoresSelecionados: [], //alterar variavel
		}
	},
	computed: {
		medicoesComputadas() {
			let medicoesParaProcessar = this.medicoesOriginal
			if (this.filtrarMedicaoBruta) {
				medicoesParaProcessar = this.medicoesOriginal.filter(
					(medicao) => medicao.medicaoProcessada === false,
				)
			}
			return medicoesParaProcessar.map((medicao) => {
				return {
					[this.$t('measurement')]: `${medicao.codigoMedicao} - ${medicao.descricaoMedicao}`,
					[this.$t('isMeasurementProcessed')]: medicao.medicaoProcessada
						? this.$t('yes')
						: this.$t('no'),
					[this.$t('serviceOrder')]:
						`${medicao.codigoOrdemServico} - ${medicao.descricaoOrdemServico}`,
					[this.$t('farm')]: `${medicao.codigoFazenda} - ${medicao.nomeFazenda}`,
					id: medicao.id,
				}
			})
		},
		isSingleTrees() {
			return this.tipoProcessamento === 'singletrees'
		},
		agregadoras() {
			return {
				tlho_cd_codigo: 'talhao',
				eiflid: 'estrato',
				ptio_dt_plantio: 'idade',
				mtge_cd_codigo: 'matgen',
				prlaid: 'parcela',
			}
		},
		edit() {
			return this.isEdit
		},
		cubagens() {
			return this.inventarioCubagens.map((cubagem) => {
				return Object.assign(cubagem, {
					[this.$t('modelName')]: cubagem.nomeModelo,
					[this.$t('code')]: cubagem.eicb_cd_codigo,
					[this.$t('description')]: cubagem.eicb_ds_descricao,
					[this.$t('type')]: cubagem.eicb_tx_tipo_modelo,
					[this.$t('logging')]: cubagem.cubagem,
				})
			})
		},
		modeloSelecionado() {
			return this.modelos.find((f) => f.stan_nm_variavel_modelo === this.modeloEscolhido)
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		ordensServicoFormatadas() {
			return this.ordensServico.map((ordem) => {
				return {
					Código: ordem.codigo,
					Descrição: ordem.descricao,
					Bitterlich: ordem.isBitterlich ? this.$t('yes') : this.$t('no'),
					Mapeado: ordem.isMapped ? this.$t('yes') : this.$t('no'),
					id: ordem.ordemServicoId,
				}
			})
		},
		produtosFormatados() {
			return this.produtos.map((produto) => {
				return {
					Nome: produto.tppr_ds_descricao,
					Código: produto.tppr_cd_codigo,
					[this.$t('logLength')]: produto.tppr_md_comprimento_tora,
					[this.$t('maxDiameter')]: produto.tppr_md_diametro_max,
					[this.$t('minDiameter')]: produto.tppr_md_diametro_min,
					id: produto.id,
				}
			})
		},
		produtosEscolhidos() {
			return this.produtos
				.filter((produto) => this.produtosSelecionados.includes(produto.id))
				.map((produto) => {
					return {
						fk_eifl_estrato_invflo: this.model.id,
						fk_tppr_produto: produto.id,
						inpr_ds_descricao: produto.tppr_ds_descricao,
						inpr_is_com_casca: false,
						inpr_md_comprimento_max: produto.tppr_md_comprimento_tora,
						inpr_md_comprimento_min: produto.tppr_md_comprimento_tora,
						inpr_md_diametro_max: produto.tppr_md_diametro_max,
						inpr_md_diametro_min: produto.tppr_md_diametro_min,
					}
				})
		},
		variaveisAgregadoras() {
			return this.variaveis.toString().replaceAll(',', ' ').trim()
		},
		isProcessamentoCubagemAfilamento() {
			if (this.model.fk_eicb_estrato_invcbg) {
				return (
					this.inventarioCubagens.find(
						(inventarioCubagem) => inventarioCubagem.id === this.model.fk_eicb_estrato_invcbg,
					).eicb_tx_tipo_modelo === 'Afilamento'
				)
			} else {
				return false
			}
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			const descricaoPreenchida = this.model.eifl_ds_descricao
			const estratoPreenchido = this.model.fk_eicb_estrato_invcbg
			const medicaoOuOrdemPreenchido =
				this.model.fk_mdco_medicao || this.model.fk_orsv_ordem_servico
			const variaveisAgregadorasPreenchidas = this.variaveisAgregadoras
			const descricaoEditada = this.isEdit ? this.model.eifl_ds_descricao !== this.descricao : true
			const produtoPreenchidoSeAfilamento = this.isProcessamentoCubagemAfilamento
				? this.produtosSelecionados.length > 0
				: true

			return (
				descricaoPreenchida &&
				estratoPreenchido &&
				medicaoOuOrdemPreenchido &&
				variaveisAgregadorasPreenchidas &&
				descricaoEditada &&
				produtoPreenchidoSeAfilamento
			)
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => {
				return model.id === value.properties.id
			})
			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
				case 'visualizar':
					getAllHipsometricoWithGraphicByEiflId(model.id).then((response) => {
						this.isEdit = true
						this.model = model
						this.modelos = response.data.result
						this.planejamentoModelo = true
					})
					// var get =
					//   model.eicb_tx_tipo_modelo === "Volumétrico"
					//     ? getAllVolumetricoWithGraphicByEicbId
					//     : getAllAfilamentoWithGraphicByEicbId;

					// this.mutationShowMessage({
					//   messageTitle: "Buscando modelo",
					//   messageText: "",
					//   messageIcon: "far fa-info-circle",
					//   messageType: "info",
					// });

					// get(model.id).then((response) => {
					//   this.isEdit = true;
					//   this.model = model;
					//   this.modelos = response.data.result;
					//   this.planejamentoModelo = true;
					// });
					break
			}
		},
		isSingleTrees(value) {
			if (value) this.nivelEstrato = ''
		},

		/**
		 * Sempre que mudar o tipo de servico zerar os valores que devem ser preenchidos
		 * que não são comuns a todas as ordens de servico
		 */
		'model.fk_tpsv_tipo_servico': function () {
			this.model.orsv_md_medida_parcela = ''
			this.model.orsv_tx_forma_parcela = ''
			this.model.orsv_md_geofence = ''
		},

		textFilter(value) {
			const pageNumber = 0
			const pageSize = 0
			this.refreshTabela(pageNumber, pageSize, value)
			this.$refs.ref__pagination.resetToFirstPageInputHandle()
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['orsv_cd_codigo']

		getAllProdutos().then((response) => {
			this.produtos = response.data.result
		})

		getAllEstratoInventarioCubagem().then((response) => {
			this.inventarioCubagens = response.data.result
		})

		getAllEstratosInventarioFlorestalPagination().then((response) => {
			const inventarios = response.data.result
			this.totalRecords = response.data.result[0].totalRegistros
			inventarios.forEach((inventario) => {
				// Convertendo a data e hora processamento  para o formato desejado dd/mm/aaaa
				let dataProcessamento = new Date(inventario.eifl_dt_processamento)
				let dia = String(dataProcessamento.getDate()).padStart(2, '0')
				let mes = String(dataProcessamento.getMonth() + 1).padStart(2, '0') // Adiciona 1 porque getMonth() retorna de 0 a 11
				let ano = dataProcessamento.getFullYear()
				let dataFormatada = `${dia}/${mes}/${ano}`
				inventario.eifl_dt_processamento = dataFormatada

				this.formataEstratoInventarioParaTabela(inventario)
			})
			this.modelList = inventarios
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		getDropdownEstratosFlorestais().then((response) => {
			this.estratosFlorestais = response
		})

		getDropdownMedicaoProcessamento().then((response) => {
			console.log('🚀 ~ getDropdownMedicaoProcessamento ~ response:', response)
			this.medicoesOriginal = response
		})

		getInstalacoesSingleTrees().then((response) => {
			this.ordensServico = response.data.result
		})
	},
	methods: {
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		handleCheckboxChange(event) {
			this.filtrarMedicaoBruta = event.target.checked
		},

		onDescriptionChange(value) {
			if (this.isEdit) {
				this.descriptionChanged = this.descricao !== value
			}
		},

		handleVariaveis(variavel) {
			if (this.variaveis.includes(variavel)) {
				this.variaveis.splice(this.variaveis.indexOf(variavel), 1)
			} else {
				this.variaveis.push(variavel)
			}

			const conjunto = ['mtge_cd_codigo', 'ptio_dt_plantio']
			this.variaveis = this.variaveis.filter((f) =>
				conjunto.includes(variavel) ? conjunto.includes(f) : f === variavel,
			)
		},

		sortConfigDate(event) {
			if (event.sortType === 'asc') {
				this.modelList.sort((a, b) => {
					let dateA = new Date(a.eifl_dt_processamento.split('/').reverse().join('-'))
					let dateB = new Date(b.eifl_dt_processamento.split('/').reverse().join('-'))
					return dateA - dateB
				})
			} else if (event.sortType === 'desc') {
				this.modelList.sort((a, b) => {
					let dateA = new Date(a.eifl_dt_processamento.split('/').reverse().join('-'))
					let dateB = new Date(b.eifl_dt_processamento.split('/').reverse().join('-'))
					return dateB - dateA
				})
			}
		},

		setarComoProcessamentoOficial(model) {
			if (model.inventarioOficial) {
				model.inventarioOficial = false
			} else {
				model.inventarioOficial = true
			}
			const inventario = {
				EstratoInventarioFlorestalId: model.id,
				SingleTrees: model.eifl_is_singletrees,
				Oficial: model.inventarioOficial,
				NovoInventario: false,
			}
			if (
				inventario.EstratoInventarioFlorestalId &&
				inventario.EstratoInventarioFlorestalId.trim() !== ''
			) {
				classificaComoInventarioOficial(inventario)
					.then((response) => {
						try {
							if (response.data.statusCode === 200) {
								this.showForm = false
								this.mutationShowMessage({
									messageTitle: this.$t('sucesso'),
									messageIcon: 'far fa-check-circle',
									messageType: 'success',
								})

								window.location.reload()
							}
						} catch (error) {
							this.mutationShowMessage({
								messageTitle: this.$t('aviso'),
								messageIcon: 'far fa-check-circle',
								messageText: error.response.data.Message,
								messageType: 'warning',
							})
						}
					})
					.catch((error) => {
						this.mutationShowMessage({
							messageTitle: this.$t('aviso'),
							messageIcon: 'far fa-check-circle',
							messageText: error.response.data.Message,
							messageType: 'warning',
						})
						this.changeFormAndCloseAllActions()
					})
			}
		},

		deletaProcessamento(estratoInventarioFlorestalId) {
			deleteEstratoInventarioFlorestalByIdList([estratoInventarioFlorestalId]).then(() => {
				const indexToRemove = this.modelList.map((m) => m.id).indexOf(estratoInventarioFlorestalId)
				this.modelList.splice(indexToRemove, 1)
			})
		},
		verPlanejamento() {
			if (this.modelos) {
				this.planejamentoModelo = true
				this.showForm = false
			}
		},
		async registraInventarioFlorestal() {
			this.processando = true
			this.mostrarLoadingProcessando = true
			this.mensagemProcessando = 'Aguarde enquanto os modelos são gerados'
			const isSubsequente = this.produtosEscolhidos && this.produtosEscolhidos.length > 0
				? true
				: this.model.eifl_is_subsequente
			this.model.eifl_is_subsequente = isSubsequente

			await createEstratoInventario({
				eifl_ds_descricao: this.model.eifl_ds_descricao,
				eifl_dt_processamento: new Date(),
				eifl_dt_referencia: new Date(),
				eifl_is_subsequente: isSubsequente,
				eifl_md_altura_toco: this.model.eifl_md_altura_toco,
				eifl_tx_var_agregadoras: this.variaveisAgregadoras,
				fk_mdco_medicao: this.model.fk_mdco_medicao,
				fk_eicb_estrato_invcbg: this.model.fk_eicb_estrato_invcbg,
				eifl_cd_codigo: 0,
				eifl_md_volume_florestal: 0,
				eifl_tx_status: '',
				eifl_tx_query_gerada: '',
				InventarioProdutos: this.produtosEscolhidos,
				fk_orsv_ordem_servico: this.model.fk_orsv_ordem_servico,
				eifl_is_singletrees: this.isSingleTrees,
				eifl_md_nivel_significancia: this.model.eifl_md_nivel_significancia,
				eifl_nm_metodologia_nfustes: this.model.eifl_nm_metodologia_nfustes,
				InventarioOficial: this.model.inventarioOficial,
				NovoInventario: true,
			})
				.then((response) => {
					this.model.id = response.data
					this.mutationShowMessage({
						messageTitle: this.$t('aviso'),
						messageText: this.$t('ajustandoModelosHipsometricos'),
						messageIcon: 'far fa-check-circle',
						messageType: 'info',
					})
					ajustaModeloHipsometrico({
						EiflId: this.model.id,
						MedicaoId: this.model.fk_mdco_medicao || this.model.fk_orsv_ordem_servico,
						VariavelAgregadora: this.variaveisAgregadoras.replace(' ', '-'),
						isSingleTrees: this.isSingleTrees,
					})
						.then((response) => {
							this.modelos = response.data.result
							this.processando = false
							this.mostrarLoadingProcessando = false
						})
						.catch(() => {
							this.planejamentoModelo = true
							this.processando = false
							this.mostrarLoadingProcessando = false
							this.mutationShowMessage({
								messageTitle: this.$t('erro'),
								messageText: this.$t('falhaAoCriarProcessamento'),
								messageIcon: 'far fa-cross-circle',
								messageType: 'error',
							})

							this.deletaProcessamento([this.model.id])
						})
				})
				.catch(() => {
					this.planejamentoModelo = true
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('falhaAoCriarProcessamento'),
						messageIcon: 'far fa-cross-circle',
						messageType: 'error',
					})

					this.deletaProcessamento([this.model.id])
				})
		},
		saveModel() {
			this.escolhendoModelo = true
			const userModules = JSON.parse(localStorage.getItem('user-modules'))

			if (
				!userModules.includes('IA_SELECTED_MODELS') &&
				this.modelos[this.index].stan_nm_variavel_modelo === 'Ajuste11'
			) {
				this.escolhendoModelo = false
				this.mutationShowMessage({
					messageTitle: this.$t('aviso'),
					messageText: this.$t('avisoSemModuloIASelectedModel'),
					messageIcon: 'fas fa-lock',
					messageType: 'warning',
				})
				return
			}

			this.mutationShowMessage({
				messageTitle: this.$t('aviso'),
				messageText: this.$t('salvandoModelo'),
				messageIcon: 'far fa-check-circle',
				messageType: 'info',
			})
			saveChosenHipsometricoModel({
				EiflId: this.model.id,
				MedicaoId: this.model.fk_mdco_medicao || this.model.fk_orsv_ordem_servico,
				ChosenModelName: this.modelos[this.index].stan_nm_variavel_modelo,
				isSingleTrees: this.isSingleTrees,
			})
				.then(() => {
					this.mutationShowMessage({
						messageTitle: this.$t('aviso'),
						messageText: this.$t('iniciandoProcessamento'),
						messageIcon: 'far fa-check-circle',
						messageType: 'info',
					})
					processaInventario({
						EiflId: this.model.id,
						EicbId: this.model.fk_eicb_estrato_invcbg,
						DiametroComercial: null,
						AlturaToco: this.model.eifl_md_altura_toco,
						IsSubsequente: this.model.eifl_is_subsequente,
						Processamento: this.isProcessamentoCubagemAfilamento ? 'Sortimento' : 'Volumetrico',
						isSingleTrees: this.isSingleTrees,
						ordemServicoId: this.model.fk_orsv_ordem_servico || null,
						nivelSignificancia: this.model.eifl_md_nivel_significancia,
						metodologiaNFustes: this.model.eifl_nm_metodologia_nfustes,
					})
						.then(() => {
							this.mutationShowMessage({
								messageTitle: this.$t('aviso'),
								messageText: 'Processando informações de qualidade para o inventário',
								messageIcon: 'far fa-check-circle',
								messageType: 'info',
							})
							if (!this.isSingleTrees) {
								processarQualidadeParaInventarioTradicional({
									idInventarioFlorestal: this.model.id,
									idMedicao: this.model.fk_mdco_medicao,
									nivelSignificancia: this.model.eifl_md_nivel_significancia,
								}).then(() => {
									this.escolhendoModelo = false
									this.planejamentoModelo = false
									this.showForm = false

									this.mutationShowMessage({
										messageTitle: this.$t('sucesso'),
										messageText: this.$t('planejamentoSalvoComSucesso'),
										messageIcon: 'far fa-check-circle',
										messageType: 'success',
									})
								})
							}
							getAllHipsometricoWithGraphicByEiflId(this.model.id).then((response) => {
								this.isEdit = true
								this.modelos = response.data.result
								this.modeloSalvo = response.data.result
								this.index = 0
								this.escolhendoModelo = false
								this.planejamentoModelo = false
								this.showForm = false
								window.location.reload()
							})
						})
						.catch(() => {
							this.mutationShowMessage({
								messageTitle: this.$t('erro'),
								messageText: this.$t('erroAoSalvarProcessamento'),
								messageIcon: 'far fa-check-circle',
								messageType: 'error',
							})

							this.escolhendoModelo = false
						})
				})
				.catch(() => {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('erroAoSalvarModelo'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				})
		},
		searchModel(text) {
			let modelo = this.modelos.find((modelo) =>
				modelo.stan_nm_titulo_modelo.toLowerCase().includes(text.toLowerCase()),
			)

			if (modelo) {
				this.index = this.modelos.indexOf(modelo)
				this.help = {}
			} else this.help = { message: this.$t('modelNotFound'), type: 'warning' }
		},
		handleClick(tipo) {
			this.avancado = tipo === 'avancado'
		},
		handleNivel(event) {
			if (event.target.id === 'matgen') {
				if (this.nivelEstrato !== 'idade') this.nivelEstrato = ''
			} else if (event.target.id !== 'idade') {
				document.getElementById('matgen').checked = false
				this.nivelMatgen = ''
			}
		},
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createEstratoInventarioToPost() {
			const dataToPost = {
				eifl_ds_descricao: this.model.eifl_ds_descricao,
				eifl_tx_var_agregadoras: this.variaveisAgregadoras,
				eifl_md_altura_toco: this.model.eifl_md_altura_toco,
				eifl_is_subsequente: this.model.eifl_is_subsequente,
				eifl_is_singletrees: this.isSingleTrees,
				eifl_nm_metodologia_nfustes: this.model.eifl_nm_metodologia_nfustes,
				eifl_md_nivel_significancia: this.model.eifl_md_nivel_significancia,
			}

			return dataToPost
		},

		create() {
			this.registraInventarioFlorestal()
		},

		update() {
			updateEstratoInventarioFlorestalAsync({
				id: this.model.id,
				eifl_ds_descricao: this.model.eifl_ds_descricao,
				eifl_tx_var_agregadoras: this.variaveisAgregadoras,
				eifl_tx_status: this.model.eifl_tx_status,
				eicb_cd_codigo: this.model.eicb_cd_codigo,
				eifl_is_singletrees: this.isSingleTrees,
				eifl_is_subsequente: this.model.eifl_is_subsequente,
				eifl_md_altura_toco: this.model.eifl_md_altura_toco,
				eifl_md_diametro_comercial: this.model.eifl_md_diametro_comercial,
				eifl_md_nivel_significancia: this.model.eifl_md_nivel_significancia,
				fk_eicb_estrato_invcbg: this.model.fk_eicb_estrato_invcbg,
				fk_mdco_medicao: this.model.fk_mdco_medicao,
				fk_orsv_ordem_servico: this.model.fk_orsv_ordem_servico,
				eifl_nm_metodologia_nfustes: this.model.eifl_nm_metodologia_nfustes,
			})
				.then(() => {
					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})

					this.showForm = false
					this.descriptionChanged = false
					window.location.reload()
				})
				.catch(() => {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('erroAoAtualizarProcessamento'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				})
		},

		/**
		 * Exclui processamento no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				let message

				var inventarioSelecionado = this.modelList.filter((inventarioFlorestal) =>
					this.modelsIdWithCheckedToDelete.includes(inventarioFlorestal.id),
				)

				var inventariosSelecionados = inventarioSelecionado.map(
					(inventarioFlorestal) =>
						`• ${inventarioFlorestal.eifl_cd_codigo} / ${inventarioFlorestal.eifl_ds_descricao}` +
						'\n',
				)

				message = inventariosSelecionados

				const confirmResult = confirm(this.$t('confirmDelete') + '\n ' + message)

				if (confirmResult) {
					deleteEstratoInventarioFlorestalByIdList(this.modelsIdWithCheckedToDelete).then(() => {
						this.modelsIdWithCheckedToDelete.forEach((f) => {
							const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
							this.modelList.splice(indexToRemove, 1)
						})
						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
						this.showExclusionAlert = false
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		handleNewSelection(inventarioFlorestal) {
			// Adiciona um novo registro à lista de registros a serem excluídos
			this.modelsIdWithCheckedToDelete.push(inventarioFlorestal.id)

			// Atualiza a lista de registros organizados
			inventarioFlorestalOrganizados.push(
				`• ${inventarioFlorestal.eifl_cd_codigo} / ${inventarioFlorestal.eifl_ds_descricao}`,
			)
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataEstratoInventarioParaTabela(ordemDeServico) {
			if (ordemDeServico.eifl_is_singletrees == true) {
				const metodologiaNumeroFustesEnum = {
					0: 'Mapeamento',
					1: 'Bitterlich',
					2: 'Roleta',
					3: 'Teórico',
					4: 'CadastroManual',
				}

				ordemDeServico.eifl_nm_metodologia_nfustes =
					metodologiaNumeroFustesEnum[ordemDeServico.eifl_nm_metodologia_nfustes] || 'Desconhecido'
			}

			ordemDeServico.estrato = ordemDeServico.esfl_cd_codigo && ordemDeServico.esfl_ds_descricao
				? `${ordemDeServico.esfl_cd_codigo} - ${ordemDeServico.esfl_ds_descricao}`
				: ordemDeServico.esfl_ds_descricao || ''

			ordemDeServico.isCheckedToDelete = false
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			// this.disableSaveButton = true;
			if (this.isEdit) {
				this.update()
			} else {
				this.planejamentoModelo = true
				this.registraInventarioFlorestal()
				this.showForm = false
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.produtosSelecionados = model.produtos?.map((m) => m.fk_tppr_produto) || []
			this.model = { ...model }
			this.descricao = this.model.eifl_ds_descricao
			this.nivelEstrato = this.agregadoras[this.model.eifl_tx_var_agregadoras] ?? null
			this.variaveis = (this.model.eifl_tx_var_agregadoras ?? '').split(' ')
			this.titleForm = `${this.$t('edit')} ${this.$t('inventoryProcessing')}`
			this.isEdit = true
			if (model.eifl_is_singletrees) {
				this.tipoProcessamento = 'singletrees'
			} else {
				this.tipoProcessamento = 'tradicional'
			}
			this.changeFormAndCloseAllActions()

			getAllHipsometricoWithGraphicByEiflId(this.model.id).then((response) => {
				this.isEdit = true
				this.model = { ...model }
				this.modelos = response.data.result
				this.modeloSalvo = response.data.result

				// this.planejamentoModelo = true;
			})
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			this.executoresSelecionados = []
			this.variaveis = []
			this.tipoProcessamento = 'tradicional'
			this.model.eifl_md_altura_toco = 0.1
			this.model.eifl_md_nivel_significancia = 0.05

			this.titleForm = `${this.$t('create')} ${this.$t('inventoryProcessing')}`
			this.isEdit = false
			this.model.inventarioOficial = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			this.modelos = []
			this.descriptionChanged = false
		},

		/**
		 * Faz o download dos dados que estao na tabela de processamentos de inventario florestal
		 */
		downloadCSVProcessamentoInventarioFlorestal() {
			let cabecalhoDoCsvInventarioFlorestal = [
				'Código',
				'Data do Processamento',
				'Descrição',
				'Estrato Florestal',
				'Ordem de Serviço',
				'Medição',
				'Estado',
				'Modelo',
			]
			const items = this.modelList

			const csv = [
				cabecalhoDoCsvInventarioFlorestal,
				...items.map((item) => [
					item.eifl_cd_codigo,
					item.eifl_dt_processamento,
					item.eifl_ds_descricao,
					item.estrato,
					item.ordemDeServico,
					item.mdco_ds_descricao,
					item.eifl_tx_status,
					item.nomeModelo,
				]),
			]
				.map((m) => m.join(';'))
				.join('\r\n')

			download(csv, 'export_processamentos_inventario_florestal.csv', 'text/csv')
		},
		refreshTabela(pageNumber, pageSize, filteringWord) {
			getAllEstratosInventarioFlorestalPagination(pageNumber, pageSize, filteringWord).then(
				(response) => {
					const inventarios = response.data.result
					this.totalRecords = response.data.result[0].totalRegistros
					if (!inventarios || inventarios.length === 0) {
						return
					}
					inventarios.forEach((inventario) => {
						// Convertendo a data e hora processamento  para o formato desejado dd/mm/aaaa
						let dataProcessamento = new Date(inventario.eifl_dt_processamento)
						let dia = String(dataProcessamento.getDate()).padStart(2, '0')
						let mes = String(dataProcessamento.getMonth() + 1).padStart(2, '0') // Adiciona 1 porque getMonth() retorna de 0 a 11
						let ano = dataProcessamento.getFullYear()
						let dataFormatada = `${dia}/${mes}/${ano}`
						inventario.eifl_dt_processamento = dataFormatada

						this.formataEstratoInventarioParaTabela(inventario)
					})
					this.modelList = inventarios
					this.tableConfiguration.statusTable = this.$t('noRecordFound')
				},
			)
		},
	},
}
</script>

<style>
.go__to__plan__text {
	margin: 0;
	text-align: end;
	font-size: 0.8rem;
	cursor: pointer;
	display: flex;
	gap: 0.5rem;
}

.go__to__plan__text:hover {
	color: var(--color-green);
}
</style>

<style scoped src="../../../css/crud.css"></style>
